import * as ComingSoon_en from './ComingSoon.en.js';
import * as ComingSoon_es from './ComingSoon.es.js';

const ComingSoonTuple = [
  { type: 'ComingSoon', language: 'en', object: ComingSoon_en.default },
  { type: 'ComingSoon', language: 'es', object: ComingSoon_es.default },
];

export default ComingSoonTuple;
